export default __webpack_public_path__ + "static/media/redlike-privilege.9c55fb4e.svg";